// extracted by mini-css-extract-plugin
module.exports = {"loading":"Loader_loading__-wOuC","animate":"Loader_animate__1YK6r","rotate":"Loader_rotate__1safu","translate":"Loader_translate__n9xh8"};